import React from "react";
import { aboutPageData } from "../data/mockData";
import { Globe, Megaphone, BarChart3, MessageSquare } from "lucide-react";

const iconList = [Globe, Megaphone, BarChart3, MessageSquare];

const AboutUs = () => {
  return (
    <div className="overflow-hidden">
      {/* Header */}
      <section className="pt-32 pb-8 md:pt-40 md:pb-12">
        <div className="max-w-[1320px] mx-auto px-6">
          <p
            className="text-[#F26522] text-[15px] font-semibold mb-2"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Urban Hunter
          </p>
          <h1
            className="text-[40px] md:text-[56px] font-bold leading-tight mb-8"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
          >
            About Us
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="pb-16 md:pb-24">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="flex flex-col md:flex-row gap-12 items-start">
            {/* Two paragraphs side by side with the image */}
            <div className="md:w-1/2 flex flex-col gap-6">
              {(aboutPageData.descriptionParagraphs || []).map((para, i) => (
                <p
                  key={i}
                  className="text-[#555] text-[16px] leading-relaxed"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {para}
                </p>
              ))}
            </div>
            <div className="md:w-1/2">
              <img
                src={aboutPageData.teamImage}
                alt="Urban Hunter Team"
                className="w-full rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 md:py-24 bg-[#FAFAFA]">
        <div className="max-w-[1320px] mx-auto px-6">
          <h2
            className="text-[28px] md:text-[36px] font-bold mb-12"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
          >
            Why Choose Us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {aboutPageData.whyChooseUs.map((item, index) => {
              const IconComp = iconList[index];
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 group"
                >
                  <div className="w-14 h-14 rounded-full bg-[#FFF3EC] flex items-center justify-center mb-5 group-hover:bg-[#F26522] transition-colors duration-300">
                    <IconComp size={24} className="text-[#F26522] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3
                    className="text-[18px] font-bold mb-3"
                    style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-[#555] text-[14px] leading-relaxed"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Official Partnerships */}
      <section className="py-16 md:py-24">
        <div className="max-w-[1320px] mx-auto px-6">
          <h2
            className="text-[28px] md:text-[36px] font-bold mb-12"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
          >
            Authorised Partnerships
          </h2>
          <div className="flex flex-wrap gap-8 items-center">
            {aboutPageData.partnerships.map((partner, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="h-[80px] md:h-[100px] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
